import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useStockItems = () => {
  return useQuery({
    queryKey: ['stockItems'],
    queryFn: async () => {
      try {
        console.log("Début de la récupération des articles...");
        
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          console.log("Aucun utilisateur connecté");
          throw new Error("Non authentifié");
        }

        console.log("Utilisateur connecté:", user.id);

        // Récupérer les données du propriétaire pour trouver le type d'entreprise
        const { data: ownerData, error: ownerError } = await supabase
          .from('owner_data')
          .select('business_type_id')
          .eq('owner_id', user.id)
          .maybeSingle();

        if (ownerError) {
          console.error("Erreur lors de la récupération des données du propriétaire:", ownerError);
          throw ownerError;
        }

        if (!ownerData?.business_type_id) {
          console.log("Type d'entreprise non défini");
          throw new Error("Type d'entreprise non défini");
        }

        console.log("Type d'entreprise trouvé:", ownerData.business_type_id);

        // Récupérer le stock de l'entreprise
        const { data: businessStocks, error: stockError } = await supabase
          .from('business_stocks')
          .select('*')
          .eq('owner_id', user.id);

        if (stockError) {
          console.error("Erreur lors de la récupération du stock:", stockError);
          throw stockError;
        }

        let stockId;
        
        // Si aucun stock n'existe, en créer un
        if (!businessStocks || businessStocks.length === 0) {
          console.log("Création d'un nouveau stock pour:", ownerData.business_type_id);
          
          const { data: newBusinessStock, error: createError } = await supabase
            .from('business_stocks')
            .insert({
              business_id: ownerData.business_type_id,
              name: 'Stock Principal',
              owner_id: user.id
            })
            .select()
            .single();

          if (createError) {
            console.error("Erreur lors de la création du stock:", createError);
            throw createError;
          }

          stockId = newBusinessStock.id;
          console.log("Nouveau stock créé avec l'ID:", stockId);
        } else {
          // Utiliser le premier stock trouvé
          stockId = businessStocks[0].id;
          console.log("Stock existant trouvé avec l'ID:", stockId);
        }

        // Récupérer les articles du stock
        const { data: items, error: itemsError } = await supabase
          .from('stock_items')
          .select('*')
          .eq('stock_id', stockId);

        if (itemsError) {
          console.error("Erreur lors de la récupération des articles:", itemsError);
          throw itemsError;
        }

        console.log("Articles trouvés:", items?.length || 0);
        return items || [];
      } catch (error: any) {
        console.error("Erreur détaillée dans useStockItems:", error);
        toast.error(error.message || "Erreur lors de la récupération du stock");
        throw error;
      }
    },
    retry: 1,
    staleTime: 1000 * 60, // 1 minute
    gcTime: 1000 * 60 * 5, // 5 minutes
  });
};